"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { usePathname, useRouter } from "next/navigation";
import { getCookie } from "cookies-next";
import { useAnalytics, useAPI } from "@travel/shared/data-access";
import { useGlobalParams } from "@travel/shared/global/data-access";
import { AuthProvider, } from "@travel/shared/auth/data-access";
import { getAccount, updateAccount, } from "../account-api/account-api";
var INITIAL_ACCOUNT_STATE = {
    account: null,
    isReady: false,
    isLoadingAccount: false,
    isCreatingAccount: false,
    isUpdatingAccount: false,
    isFinishedSubscription: false,
    update: function () { return Promise.resolve(null); },
    set: function () { },
    finishedSubscription: function () { },
};
export var AccountContext = createContext(INITIAL_ACCOUNT_STATE);
export function AccountProvider(_a) {
    var children = _a.children, _b = _a.defaultUser, defaultUser = _b === void 0 ? null : _b, _c = _a.defaultAccount, defaultAccount = _c === void 0 ? null : _c;
    var pathname = usePathname();
    var refresh = useRouter().refresh;
    var identify = useAnalytics().identify;
    var _d = __read(useState(defaultUser), 2), user = _d[0], setUser = _d[1];
    var _e = __read(useState(!!defaultUser && !!defaultAccount), 2), isReady = _e[0], setIsReady = _e[1];
    var _f = __read(useState(defaultAccount), 2), account = _f[0], setAccount = _f[1];
    var accountRef = useRef();
    var userRef = useRef(null);
    var initializedWithUserRef = useRef(!!defaultUser);
    var initializedWithAccountRef = useRef(!!defaultAccount);
    var waitForAccount = initializedWithUserRef.current && !initializedWithAccountRef.current;
    var _g = __read(useState(false), 2), isCreatingAccount = _g[0], setIsCreatingAccount = _g[1];
    var _h = __read(useState(false), 2), isUpdatingAccount = _h[0], setIsUpdatingAccount = _h[1];
    var bypassMember = getCookie("bypass-member");
    var accountOptions = useMemo(function () {
        return bypassMember
            ? {
                headers: {
                    signup: 1,
                },
            }
            : undefined;
    }, [bypassMember]);
    var _j = useAPI(!account && user ? {} : null, getAccount, accountOptions), clientAccount = _j.data, isLoadingAccount = _j.isLoading;
    var _k = __read(useState(!!(account === null || account === void 0 ? void 0 : account.isVIP)), 2), isFinishedSubscription = _k[0], setIsFinishedSubscription = _k[1];
    var loginFailSafeRef = useRef();
    var _l = __read(useGlobalParams(), 2), updateGlobalParams = _l[1].update;
    var handleUserChange = useCallback(function (nextUser, event) {
        var _a;
        var shouldRefresh = (nextUser === null || nextUser === void 0 ? void 0 : nextUser.id) !== ((_a = userRef.current) === null || _a === void 0 ? void 0 : _a.id) && !(pathname === null || pathname === void 0 ? void 0 : pathname.match(/login/g));
        userRef.current = user;
        setUser(nextUser);
        if (shouldRefresh &&
            event &&
            event !== "signOut" &&
            event !== "unauthenticated") {
            refresh();
        }
        if (user) {
            loginFailSafeRef.current = clearTimeout(loginFailSafeRef.current);
            setIsReady(true);
        }
        else if (event === "unauthenticated") {
            loginFailSafeRef.current = setTimeout(function () {
                setIsReady(true);
            }, 8000);
        }
    }, [user, account, isReady]);
    useEffect(function () {
        if ((defaultUser === null || defaultUser === void 0 ? void 0 : defaultUser.isAuthenticated) && !account) {
            //createAccount(defaultUser);
        }
    }, [defaultUser, account, waitForAccount]);
    useEffect(function () {
        setAccount(defaultAccount);
    }, [defaultAccount]);
    useEffect(function () {
        if (account) {
            var _a = account.attribution, campaign = _a.campaign, cid = _a.cid;
            identify(account.id, {
                //@TODO: Fix typing
                name: account.firstName
                    ? "".concat(account.firstName, " ").concat(account.lastName)
                    : "",
                email: account.email,
            });
            updateGlobalParams({ campaign: campaign, cid: cid }, false);
            setIsReady(true);
        }
    }, [account]);
    useEffect(function () {
        accountRef.current = account || clientAccount;
    }, [account === null || account === void 0 ? void 0 : account.id, clientAccount === null || clientAccount === void 0 ? void 0 : clientAccount.id]);
    return (_jsx(AuthProvider, { defaultUser: defaultUser, onUserChange: handleUserChange, children: _jsx(AccountContext.Provider, { value: {
                account: clientAccount || account,
                isReady: isReady,
                isLoadingAccount: isLoadingAccount,
                isCreatingAccount: isCreatingAccount,
                isUpdatingAccount: isUpdatingAccount,
                isFinishedSubscription: isFinishedSubscription,
                update: update,
                set: setAccount,
                finishedSubscription: function () { return setIsFinishedSubscription(true); },
            }, children: children }) }));
    function createAccount(user) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsCreatingAccount(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, updateAccount({
                                email: user.email,
                                accessToken: (_a = user === null || user === void 0 ? void 0 : user.tokens) === null || _a === void 0 ? void 0 : _a.access,
                            })];
                    case 2:
                        result = _b.sent();
                        setAccount(result);
                        return [2 /*return*/, result];
                    case 3:
                        error_1 = _b.sent();
                        console.log(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        setIsCreatingAccount(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function update(patch, silent) {
        if (silent === void 0) { silent = false; }
        return __awaiter(this, void 0, void 0, function () {
            var account, result, firstName, lastName, phones, travelers, hasSkippedMembership, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        account = accountRef.current;
                        if (!account)
                            throw new Error("Cannot update unauthenticated user");
                        setIsUpdatingAccount(true);
                        result = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        if (!silent) return [3 /*break*/, 2];
                        result = __assign(__assign({}, account), patch);
                        setAccount(result);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, updateAccount(patch)];
                    case 3:
                        result = _a.sent();
                        firstName = result.firstName, lastName = result.lastName, phones = result.phones, travelers = result.travelers, hasSkippedMembership = result.hasSkippedMembership;
                        setAccount(__assign(__assign({}, account), { firstName: firstName, lastName: lastName, phones: phones, travelers: travelers, hasSkippedMembership: hasSkippedMembership }));
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_2 = _a.sent();
                        console.error(error_2);
                        return [3 /*break*/, 6];
                    case 6:
                        setIsUpdatingAccount(false);
                        return [2 /*return*/, result];
                }
            });
        });
    }
}
